import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, ValidatorFn, Validators } from '@angular/forms';


@Component({
    selector: 'app-input-base-react',
    template: ''
})

export class InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges, OnDestroy {

    //#region .  Variáveis  .
    validators: Array<ValidatorFn> = [];
    //#endregion

    //#region .  Inputs / Outputs  .
    @ViewChild('field') field: ElementRef;

    @Input() id: string = null;
    @Input() form: AbstractControl;
    @Input() value: any;
    @Input() name: string;
    @Input() required = false;
    @Input() readOnly = false;
    @Input() detailMode = false;
    @Input() includeLabel = true;
    @Input() labelName?: string = undefined;
    @Input() includeSpan?: boolean = undefined;
    @Input() placeholder = '';

    // tslint:disable-next-line:prefer-output-readonly
    @Output() valorChange: EventEmitter<string> = new EventEmitter<string>();

    protected control: FormControl = undefined;
    public spanRequired?: string = undefined;
    //#endregion

    //#region .  Getters and Setters  .
    get getvalue(): string {
        return this.value;
    }

    set setvalue(val) {
        this.value = val;
        this.valorChange.emit(this.value);
        this.onChange(this.value);
        this.onTouched();
    }
    //#endregion

    protected onChange: any = () => { };

    protected onTouched: any = () => { };

    //#region .  LifeCycle Methods e Construtor  .
    constructor(
    ) {

    }

    @HostListener('unloaded')
    ngOnDestroy(): void {
    }

    pressKey(event) {
        this.valorChange.emit(event);
    }

    ngOnInit(): void {
        // efetua instância objeto FormControl a partir de nome do input passado para o component
        if (this.form) {
            const comp = this.form.get(this.name);

            if (comp instanceof FormControl) {
                this.control = comp as FormControl;
            }

            if (this.value) {
                if (this.control) {
                    this.control.setValue(this.value);
                    this.valorChange.emit(this.value);
                }
            }
        }

        // prepara valor de span de obrigatoriedade
        if (!this.includeLabel) {
            this.spanRequired = 'O preenchimento do campo é obrigatório';
        } else
            if (!this.spanRequired) {
                this.spanRequired =
                    this.labelName ? `${this.labelName} é obrigatório` : this.spanRequired = `${this.name} é obrigatório`;
            }

        //
        if (this.includeSpan === null) {
            this.includeSpan = this.required ? true : false;
        }

        // caso o preenchimento do component seja obrigatório, é inserido validador
        if (this.required) {
            this.insertValidator(Validators.required);
        }
    }

    ngOnChanges(): void {
        // caso o component sofra alguma mudança, o evento será disparado.
        // a rotina abaixo re-atribui o validador de obrigatoriedade, para componentes que possuem obrigatoriedade condicional.
        if (this.control) {
            this.clearValidators();
            if (this.required) {
                this.insertValidator(Validators.required);
            }
        }
    }
    //#endregion

    //#region .  Métodos  .

    // método para inserção de validadores
    protected insertValidator(value: ValidatorFn): void {
        this.validators.push(value);
    }

    // metodo para limpar a lista de validadores
    protected clearValidators(): void {
        this.validators = [];
        this.control.clearValidators();
    }

    // metodo para setar validadores no component
    // o método deve ser chamado por todos os components que herdarem a classe no método ngOnInit
    protected setAndUpdateValidators(): void {
        setTimeout(() => {
            if (this.control) {
                this.control.setValidators(this.validators);
                this.control.updateValueAndValidity();
            }
        });
    }

    protected convertBool(value) {
        switch (value) {
            case 'true': return true;
            case 'false': return false;
            case 'null': return null;
        }
    }

    protected getValueFromRichEditor() {
        const field = this.field as any;
        const value = field.elementRef.nativeElement.getElementsByClassName('ql-editor')[0].innerHTML;

        return value;
    }

    // método utilizado nos eventos input/ change dos components para modificar a propriedade value do component
    public changeValue(event, isBoolean = false, isNumber = false, isFloat = false, isRichEditor = false): void {
        let newValue = (
            isBoolean ? this.convertBool(this.field.nativeElement.value) :
                isNumber ? parseInt(this.field.nativeElement.value, 0) :
                    isFloat ? parseFloat(this.field.nativeElement.value) :
                        isRichEditor ? this.getValueFromRichEditor() :
                            this.field.nativeElement.value);

        if (newValue === 'null') {
            newValue = null;
        }

        if (isFloat && isNaN(newValue)) {
            newValue = null;
        }

        if (isRichEditor) {
            if (newValue === '<p><br></p>') {
                newValue = null;
            }
        }

        if (this.control) {
            this.control.setValue(newValue);
        }

        this.value = newValue;
        this.onChange(newValue);
        this.onTouched();

        if (this.valorChange !== undefined) {
            this.valorChange.emit(newValue);
        }
    }

    // método para retornar o label que será utilizado juntamente ao input do component
    public getLabelName(): string {
        if (this.labelName) {
            return this.labelName;
        } else {
            return this.name;
        }
    }

    // método para retornar se o component é obrigatório
    public validateRequired(): boolean {
        return this.control?.errors?.required && this.required;
    }

    // métodos obrigatórios para componentes que herdam da classe ControlValueAccessor
    writeValue(obj: any): void {
        try {
            this.value = obj;
        } catch (err) { }// necessário para cenários onde o formulario (FormGroup) é alterado no componente pai
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        // do nothing
    }
    // im Métodos ControlValueAccessor

    //#endregion
}
